import React from "react";

export function EliminaUtente() {
  return(
    <p>Elimina utente</p>
  ) 
} 							

export default EliminaUtente